import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const TasksLink = () => {

  return (
    <AsideMenuLink
      pathname={P.TASKS_PAGE}
      subject={S.TASKS_PAGE}
      icon={'Tasks_secondary.svg'}
      label={<FormattedMessage id="tasks-page-link" defaultMessage="Tasks"/>}
    />
  );
};

export default TasksLink;
